import { render, staticRenderFns } from "./dui-option.vue?vue&type=template&id=12da95a0&"
import script from "./dui-option.vue?vue&type=script&lang=js&"
export * from "./dui-option.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports